import "./MediaButton.css";

/**
 * 
 * @param {{
 *   children: React.ReactNode,
 *   disabled: boolean,
 *   pressed: boolean,
 *   size: "sm" | "md" | "lg",
 *   variant: "default" | "red",
 *   onClick: () => void,
 * }} params 
 * @returns
 */
const MediaButton = ({
    children,
    disabled = false,
    pressed = false,
    size = "md",
    variant = "default",
    onClick = () => { },
}) => {

    return (
        <button
            disabled={disabled}
            className={`mediabutton-container mediabutton-${size} mediabutton-variant-${variant} ${pressed ? "mediabutton-pressed" : ""}`}
            onClick={onClick}>
            <div className={`mediabutton-content mediabutton-content-variant-${variant}`}>
                {children}
            </div>
            {/* pressed mask */}
            {pressed && <div className="mediabutton-pressed-mask" />}
        </button>
    )
}

export default MediaButton;